module.exports = __webpack_public_path__ + "img/长条图.e0b46ffc.jpg";